const moment = require('moment-timezone');

const formatDate = {
  methods: {
    formatDate(isoDate) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment(isoDate).tz(timeZone).format('MM-DD-YYYY hh:mm A z');
    },
    getMonthDay(isoDate) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment(isoDate).tz(timeZone).format('MM-DD-YYYY');
    },
  },
};

module.exports = {
  formatDate,
};



// WEBPACK FOOTER //
// ./src/mixins/format-date.js